import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PathsOptIn_FeatureFlagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PathsOptIn_FeatureFlagsQuery = { __typename?: 'Query', FeatureFlags: Array<{ __typename?: 'FeatureFlag', name: string, adminSelfServable?: boolean | null }> };


export const PathsOptIn_FeatureFlagsDocument = gql`
    query PathsOptIn_FeatureFlags {
  FeatureFlags {
    name
    adminSelfServable
  }
}
    `;

/**
 * __usePathsOptIn_FeatureFlagsQuery__
 *
 * To run a query within a React component, call `usePathsOptIn_FeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathsOptIn_FeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathsOptIn_FeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathsOptIn_FeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<PathsOptIn_FeatureFlagsQuery, PathsOptIn_FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PathsOptIn_FeatureFlagsQuery, PathsOptIn_FeatureFlagsQueryVariables>(PathsOptIn_FeatureFlagsDocument, options);
      }
export function usePathsOptIn_FeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PathsOptIn_FeatureFlagsQuery, PathsOptIn_FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PathsOptIn_FeatureFlagsQuery, PathsOptIn_FeatureFlagsQueryVariables>(PathsOptIn_FeatureFlagsDocument, options);
        }
export type PathsOptIn_FeatureFlagsQueryHookResult = ReturnType<typeof usePathsOptIn_FeatureFlagsQuery>;
export type PathsOptIn_FeatureFlagsLazyQueryHookResult = ReturnType<typeof usePathsOptIn_FeatureFlagsLazyQuery>;
export type PathsOptIn_FeatureFlagsQueryResult = Apollo.QueryResult<PathsOptIn_FeatureFlagsQuery, PathsOptIn_FeatureFlagsQueryVariables>;